function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getTaskListLeftFilterHeaderStyle = function getTaskListLeftFilterHeaderStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty({
    padding: '12px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // antd css
    '.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets': {
      minWidth: '90px'
    },
    '.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul': {
      paddingTop: '40px',
      textAlign: 'center'
    },
    // antd css
    '.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li:hover': {
      backgroundColor: '#00000000'
    },
    '.dataPickerPreset': {
      padding: '4px 18px'
    },
    '.dataPickerPreset:hover': {
      color: '#000000D9',
      backgroundColor: '#f0f5ff',
      opacity: 0.6
    },
    '.presetSelected': {
      color: '#000000D9',
      backgroundColor: '#f0f5ff'
    }
  }, ".filter-control", {
    display: 'flex',
    fontSize: '14px',
    color: '#6E707A',
    alignItems: 'center'
  }), '.filter-item', {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    // padding: 6,
    gap: 4,
    '.padding': {
      padding: '6px'
    },
    '&:hover': {
      borderRadius: 2,
      background: '#F6F6F9',
      color: '#6E707A'
    },
    '&.selected': {
      color: '#4C65ED',
      fontWeight: 500
    },
    '.range-picker': {
      opacity: 0,
      width: '1px',
      height: '20px',
      position: 'absolute',
      top: '10px',
      left: '0',
      zIndex: -100
    },
    '.range-picker-footer': {
      textAlign: 'center'
    }
  }));
};
export var getFilterItemRangePickerFooterStyle = function getFilterItemRangePickerFooterStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), {
    textAlign: 'right'
  });
};